export default class ProductFinderEvent {
  event = {
    event: 'search.ProductFinder',
  };

  constructor(filters, attributeFilters, rangeAttributeFilters, resultCount)
  {
    this.setResult(resultCount);
    this.setGroup(filters.group);
    this.setCategory(filters.category);
    this.setLineup(filters.lineup);
    this.setSeries(filters.series);
    this.setSearch(filters.search);
    this.setFilterSelection(attributeFilters, rangeAttributeFilters);
  }

  setResult(resultCount)
  {
    if (resultCount > 0) {
      this.event['search.resultSuccess'] = true;
    } else if (resultCount === 0) {
      this.event['search.NoResults'] = true;
    }
  }

  setGroup(group)
  {
    if (group) this.event['enter.group'] = group;
  }

  setCategory(category)
  {
    if (category) this.event['selected.category'] = category;
  }

  setLineup(lineup)
  {
    if (lineup) this.event['selected.lineup'] = lineup;
  }

  setSeries(series)
  {
    if (series) this.event['selected.series'] = series;
  }

  setSearch(search)
  {
    if (search) this.event['enter.ProductTerm'] = search;
  }

  setFilterSelection(attributeFilters, rangeAttributeFilters)
  {
    let attributeFiltersArray = [];
    for (let prop in attributeFilters) {
      attributeFiltersArray.push(prop + ':' + attributeFilters[prop]);
    }
    for (let prop in rangeAttributeFilters) {
      attributeFiltersArray.push(prop + ':' +  rangeAttributeFilters[prop].join('-'));
    }
    if (attributeFiltersArray.length > 0) {
      this.event['dynamic.FilterSelections'] = attributeFiltersArray.join('|');
    }
  }

  getEvent()
  {
    return this.event;
  }
}
